export default "https://cdn-static.gokick.com/assets/8bc125c24491fd75c87852671f08945500f37a20/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";